import React from 'react';
import PropTypes from 'prop-types';
import Input from "../Application/Input";
import useAfterUpdateEffect from "../../utils/useAfterUpdateEffect";
import Tooltip from "../../componentsReusable/Tooltip";
import {isEmpty} from "lodash";
import nl2br from "react-nl2br";

const ClientDescription = props => {
  const [value, setValue] = React.useState(props.value);
  const [isEditing, setIsEditing] = React.useState(false);

  useAfterUpdateEffect(() => {
    if(props.value !== value){
      setValue(props.value)
    }
  }, [props.value])

  useAfterUpdateEffect(() => {
    if(props.onToggleEditing){
      props.onToggleEditing(isEditing)
    }
  }, [isEditing])

  useAfterUpdateEffect(() => {
    props.onChange(value)
  }, [value])

  if(isEditing){
    return <Input
      autoFocus
      placeholder="Opis klienta"
      rows={4}
      size="sm"
      type="textarea"
      value={value}
      onChange={value => setValue(isEmpty(value) ? null : value)}
      onBlur={() => setIsEditing(false)}
    />
  }

  return (
    <span
      className="text-secondary text-justify cursor-pointer"
      style={{ lineHeight: '13px' }}
      onClick={() => setIsEditing(true)}
    ><Tooltip msg="Kliknij, aby edytować opis klienta">{value ? <span>{nl2br(value)}</span> : <i>Brak opisu klienta</i>}</Tooltip></span>
  );
};

ClientDescription.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onToggleEditing: PropTypes.func,
};

export default ClientDescription;
